export default function hasChanged(a, b) {
  return JSON.stringify(a) !== JSON.stringify(b)
}
